import { theme } from '~/theme';

export const tableRowHeight = 48;

export const useSxStyles = () => {
  return {
    dialogContentExpansionPanel: {
      padding: 0,
    },
    dialogContentSimpleTable: {
      padding: theme.spacing(0, 1, 1, 1),
    },
    expansionPanelSummaryRoot: {
      paddingLeft: theme.spacing(),
    },
    expansionPanelSummaryContent: {
      overflow: 'hidden',
    },
    expansionPanelDetailsRoot: {
      paddingTop: 0,
      paddingLeft: theme.spacing(3),
    },
    tableContainer: {
      overflow: 'hidden',
      '& tbody tr': { height: tableRowHeight },
    },
  };
};
